
import cInput from "@/components/FormElements/CustomInput.vue";
import { Vue, Component, Prop } from "vue-property-decorator";
import DatePicker from "vuejs-datepicker";
import ebSelect from "@/components/FormElements/Select.vue";

@Component({
  components: {
    cInput,
    ebSelect,
    DatePicker
  }
})
export default class Agreement extends Vue {
  get marketOptions() {
    return [
      {
        label: "MARKET",
        value: "MARKET"
      }
      // {
      //   label: "Domain",
      //   value: "DOMAIN"
      // },
      // {
      //   label: "Product Type",
      //   value: "PRODUCT_TYPE"
      // },
      //   {
      //     label: "CATEGORY",
      //     value: "CATEGORY"
      //   }
    ];
  }

  @Prop()
  private catalogData!: any;

  @Prop()
  private marketListStore!: any;
  @Prop()
  private catalogCategoryNames!: any;

  @Prop()
  private catalogCategoryOptionsProp!: any;

  get catalogsOptionsMarket() {
    try {
      if (
        Array.isArray(this.marketListStore) &&
        this.marketListStore.length > 0 &&
        this.marketListStore[0].isMarket
      ) {
        return this.marketListStore;
      } else {
        return [];
      }
    } catch {
      return [];
    }
  }

  get catalogsOptionsAll() {
    let catalogs = this.$store.getters["catalog/GetCatalogTree"];

    let filtercatalogs = [];

    if (this.agreement.market === null) {
      return [];
    } else if (this.agreement.market.value === "DOMAIN") {
      console.log(catalogs, this.agreement.market.value);
      filtercatalogs = catalogs.filter(obj => obj.isDomain);
      return filtercatalogs;
    } else if (this.agreement.market.value === "MARKET") {
      filtercatalogs = catalogs.filter(obj => obj.isMarket);
      return filtercatalogs;
    } else if (this.agreement.market.value === "PRODUCT_TYPE") {
      filtercatalogs = catalogs.filter(obj => obj.isProductType);
      return filtercatalogs;
    } else if (this.agreement.market.value === "CATEGORY") {
      filtercatalogs = catalogs.filter(obj => obj.isCategory);
      return filtercatalogs;
    }
  }

  private async fetchAllSelectedMarketCatagory() {
    this.agreement.catalogCategory = [];
    this.catalogsOptionsCategory = [];

    let data = this.agreement.catalog;

    try {
      if (Array.isArray(data) && data.length > 0) {
        let searchString = "";
        this.isLoadingCat = true;
        data.forEach(async el => {
          searchString = `parent=${el._id}`;
          await this.$store.dispatch("catalog/fetchCatalogList", searchString);
          this.catalogsOptionsCategory.push(
            ...this.$store.getters["catalog/GetCategoryList"].data.response
          );
        });

        this.isLoadingCat = false;
      }
    } catch {
      this.catalogsOptionsCategory = [];
    }

    if (Array.isArray(data) && data.length == 0) {
      this.catalogsOptionsCategory = [];
    }
  }
  private sameObjCount: any = [];
  private catalogsOptionsCategory: any = [];
  private isMarketShow: Boolean = false;
  private isLoading: Boolean = false;
  private isLoadingCat: Boolean = false;
  private agreement: any = {
    market: null,
    catalog: [],
    catalogCategory: "",
    file: "",
    startDate: new Date(),
    endDate: new Date(),
    UPIID: "",
    fetchCatagoryKey: false
  };
  private readAgreement(e) {
    this.uploadFile(e.target.files[0]);
  }
  private async uploadFile(file) {
    let formdata = new FormData();
    formdata.append("file", file);
    formdata.append(
      "key",
      (
        Date.now().toString(36) +
        Math.random()
          .toString(36)
          .substr(2, 5)
      ).toLowerCase()
    );
    formdata.append("isPublic", JSON.stringify(true));
    formdata.append("replaceExisting", JSON.stringify(true));
    formdata.append("basePath", "partner");
    this.showCustomToast();
    await this.$store
      .dispatch("inventory/uploadFileToStorage", formdata)
      .then(res => {
        this.agreement.doc = res.data.fileUrl;
      })
      .catch(error => {
        this.$swal({
          type: "error",
          text: "File Upload failed! please try again."
        });
        this.clearCustomToast();
      });
  }
  private showCustomToast() {
    Vue.toasted.show("Uploading...", {
      type: "info",
      theme: "toasted-primary",
      singleton: true,
      duration: 1000
    });
  }
  private clearCustomToast() {
    Vue.toasted.clear();
  }

  private async mounted() {
    if (
      this.$store.getters["partner/GetPartnerData"].agreement.marketSegment[0]
        .categoryType == "MARKET"
    ) {
      this.agreement.catalog = this.catalogData;
      this.catalogsOptionsCategory = this.catalogCategoryOptionsProp;
    } else {
      this.agreement.fetchCatagoryKey = true;
      this.agreement.catalogCategory = this.catalogData;
      this.agreement.catalog = this.catalogCategoryNames;
      this.catalogsOptionsCategory = this.catalogCategoryOptionsProp;
    }

    this.agreement.market = {
      label: "MARKET",
      value: "MARKET"
    };

    let storageDataUser: any = sessionStorage.getItem("userLogin");
    let dataDomain = JSON.parse(storageDataUser).catalogInfo;

    if (
      Array.isArray(dataDomain) &&
      dataDomain.length > 0 &&
      dataDomain[0].categoryType == "CATEGORY"
    ) {
      this.isMarketShow = false;
      this.agreement.fetchCatagoryKey = true;
    } else {
      this.isMarketShow = true;
    }
  }
}
